export default __webpack_public_path__ + "static/media/pdf-icon.cda09c29.png";